import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacheantComponent } from './simple-icons-apacheant.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacheantComponent ],
    exports:      [ SimpleIconsApacheantComponent ],
    bootstrap:    []
})
export class SimpleIconsApacheantModule {}
